//
import Model from '@/models/Model'

/**
 * This class describes wh product stocks.
 *
 * @class      WhProductStocks (name)
 */
export default class WhProductStocks extends Model {

  /**
   * { item_description }
   */
  //static appends = ['stocks']

  /**
   * { item_description }
   */
  static includes = ['wh_item']

  resource() {
  	return 'wh_product_stocks'
  }

  /**
   * Returns a search representation of the object.
   *
   * @return     {<type>}  Search representation of the object.
   */
  toSearch() {
  	return this.clean([
  		'wh_product_ids',
  		'wh_warehouse_id',
  		'wh_warehouse_extra_id',
  	])
  }
}
